// extracted by mini-css-extract-plugin
export default {"videoPlayer":"video-player__videoPlayer--1bccG"};
    if(module.hot) {
      // 1777559903004
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  